export enum appModeItem {
  Standalone = 1,
  Browser = 2,
}
export function appMode() {
  return window.matchMedia("(display-mode: standalone)").matches // || true
    ? appModeItem.Standalone
    : appModeItem.Browser;
}
